<script lang="ts" setup>
import { computed } from 'vue'

import { getCurrentXG } from '@mobile/views/Relation/DetailsPanel/utils'
import { ProbableLinkedIncident } from '@mobile/views/Relation/Shared/RelationDependencies/types'
import { useSportConfiguration } from '@mobile/views/Relation/Shared/RelationSportCommonDependencies/useSportConfiguration'

type Props = {
  linkedIncident: ProbableLinkedIncident
}

const props = defineProps<Props>()

const { eventClockConfiguration } = useSportConfiguration()

// data
const [minute, second] = props.linkedIncident.incident.event_time?.split(
  ':',
) ?? ['--', '--']
const time = {
  minute,
  second,
}

// computed
const currentXG = computed(() =>
  getCurrentXG(props.linkedIncident.incident.properties),
)
</script>

<template>
  <div
    class="bg-lightgray border-gray mb-3 rounded-sm border border-solid px-3 py-3"
  >
    <span
      v-if="eventClockConfiguration.isEnabled"
      class="pr-4"
    >
      {{ time.minute }}:{{ time.second }}
    </span>
    <span class="pr-4">{{ linkedIncident.incident.event_status_name }}</span>
    <span class="pr-1 font-bold">
      {{ linkedIncident.incident.participant_name }}
    </span>
    <span class="pr-1 font-bold">-</span>
    <span class="pr-1 font-bold">
      {{ linkedIncident.incident.incident_name }}
    </span>
    <span
      v-if="currentXG !== undefined"
      class="pr-1 font-bold"
    >
      (xG = {{ currentXG }})
    </span>
  </div>
</template>
